export default "__VITE_ASSET__BI8kaIK$__"